import { config } from './env';

export const PAYMENT_CONFIG = {
  MERCHANT_ID: 'PBS0020',
  PR_MERCHANT_ID: 'PBS0034',
  API_BASE_URL: config.apiBaseUrl,
  SCRIPT_VERSION: '72',
  get SCRIPT_URL() {
    // return `https://test-gateway.mastercard.com/form/version/${this.SCRIPT_VERSION}/merchant/${this.MERCHANT_ID}/session.js`;
    return `https://ap-gateway.mastercard.com/form/version/${this.SCRIPT_VERSION}/merchant/${this.PR_MERCHANT_ID}/session.js`;
  },
  SCRIPT_ID: 'mastercard-payment-script'
};